webpackJsonp([20],{

/***/ 776:
/*!************************************************!*\
  !*** ./node_modules/lodash/_isIterateeCall.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(/*! ./eq */ 121),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 72),
    isIndex = __webpack_require__(/*! ./_isIndex */ 129),
    isObject = __webpack_require__(/*! ./isObject */ 51);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 780:
/*!*************************************!*\
  !*** ./node_modules/lodash/some.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(/*! ./_arraySome */ 407),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 120),
    baseSome = __webpack_require__(/*! ./_baseSome */ 781),
    isArray = __webpack_require__(/*! ./isArray */ 11),
    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ 776);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ 781:
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseSome.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(/*! ./_baseEach */ 122);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ 836:
/*!******************************************!*\
  !*** ./node_modules/lodash/mapValues.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 390),
    baseForOwn = __webpack_require__(/*! ./_baseForOwn */ 415),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 120);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 837:
/*!**************************************!*\
  !*** ./node_modules/lodash/keyBy.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 390),
    createAggregator = __webpack_require__(/*! ./_createAggregator */ 417);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),

/***/ 838:
/*!****************************************!*\
  !*** ./node_modules/lodash/isEqual.js ***!
  \****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ 133);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 865:
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/products/VariantsGeneratorForm.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/toConsumableArray */ 131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(/*! ./node_modules/babel-runtime/core-js/object/keys */ 925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapValues__ = __webpack_require__(/*! lodash/mapValues */ 836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(/*! lodash/map */ 731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some__ = __webpack_require__(/*! lodash/some */ 780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__ = __webpack_require__(/*! lodash/keyBy */ 837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pick__ = __webpack_require__(/*! lodash/pick */ 835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__ = __webpack_require__(/*! lodash/isEqual */ 838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flatten__ = __webpack_require__(/*! lodash/flatten */ 746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_types__ = __webpack_require__(/*! ../../common/types */ 790);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormMultiselect: function FormMultiselect() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/form/FormMultiselect */ 711));
    }
  },
  props: {
    value: Object
  },
  data: function data() {
    return {
      variantsOptions: {},
      deleteOldVariants: false,
      deleteInvalidVariants: true
    };
  },

  computed: {
    invalidVariants: function invalidVariants() {
      var properties = this.productPropertiesToChoose;
      return (this.value && this.value.variants || []).filter(function (_ref) {
        var attributes = _ref.attributes;

        var propertiesWithValidValue = properties.filter(function (_ref2) {
          var id = _ref2.id,
              kind = _ref2.kind,
              required = _ref2.required,
              colors = _ref2.colors,
              tags = _ref2.tags;

          var attribute = (attributes || []).find(function (_ref3) {
            var property = _ref3.property;
            return property === id;
          });
          if (!attribute) return false; // Aucun attribut pour cette propriété
          if (!attribute.value) return !required; // Aucune valeur pour l'attribut obligatoire
          switch (kind) {
            case 'color':
              return !!colors.find(function (_ref4) {
                var id = _ref4.id;
                return id === attribute.value;
              });
            case 'tag':
              return tags.indexOf(attribute.value) !== -1;
            case 'sex':
              return __WEBPACK_IMPORTED_MODULE_9__common_types__["f" /* ProductPropertySexOptionsArray */].find(function (_ref5) {
                var value = _ref5.value;
                return attribute.value === value;
              });
          }
          return false;
        });
        return propertiesWithValidValue.length !== properties.length;
      });
    },
    oldVariants: function oldVariants() {
      var propertiesToFind = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(this.productPropertiesToChoose, 'id');
      var attributesToFindObject = this.variantsOptions;
      var invalidVariants = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(this.invalidVariants, 'id');
      return (this.value && this.value.variants || []).filter(function (_ref6) {
        var attributes = _ref6.attributes;

        var attributesObject = __WEBPACK_IMPORTED_MODULE_6_lodash_pick___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_mapValues___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default()(attributes, 'property'), 'value'), propertiesToFind);
        var hasNoAttributeValueSelected = __WEBPACK_IMPORTED_MODULE_4_lodash_some___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(attributesObject, function (value, prop) {
          return (attributesToFindObject[prop] || ['']).indexOf(value) === -1;
        }));
        return hasNoAttributeValueSelected;
      }).filter(function (_ref7) {
        var id = _ref7.id;
        return invalidVariants.indexOf(id) === -1;
      });
    },
    productPropertiesToChoose: function productPropertiesToChoose() {
      return (this.value && this.value.properties || []).filter(function (_ref8) {
        var kind = _ref8.kind;
        return kind !== 'text';
      });
    },
    totalVariantsCount: function totalVariantsCount() {
      var _this = this;

      var values = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(this.productPropertiesToChoose, function (_ref9) {
        var id = _ref9.id,
            required = _ref9.required;
        return (_this.variantsOptions[id] || (required ? [] : [''])).length;
      });
      var total = values.reduce(function (total, multiple) {
        return total * multiple;
      }, 1);
      return total;
    },
    existingVariantsCount: function existingVariantsCount() {
      return this.value.variants.length;
    },
    newVariantsCount: function newVariantsCount() {
      return this.totalVariantsCount - this.existingVariantsCount + this.invalidVariants.length;
    }
  },
  methods: {
    getPropertyOptions: function getPropertyOptions(property) {
      switch (property.kind) {
        case 'color':
          return __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(property.colors, function (_ref10) {
            var id = _ref10.id,
                name = _ref10.name;
            return { value: id, label: name };
          });
        case 'tag':
          return __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(property.tags, function (tag) {
            return { value: tag, label: tag };
          });
        case 'sex':
          return __WEBPACK_IMPORTED_MODULE_9__common_types__["f" /* ProductPropertySexOptionsArray */];
      }
      return [];
    },
    getVariantWithAttributes: function getVariantWithAttributes(attributesToFind) {
      var attributesToFindObject = __WEBPACK_IMPORTED_MODULE_2_lodash_mapValues___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default()(attributesToFind, 'property'), 'value');
      var propertiesToFind = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_core_js_object_keys___default()(attributesToFindObject);
      return (this.value && this.value.variants || []).find(function (_ref11) {
        var attributes = _ref11.attributes;

        var attributesObject = __WEBPACK_IMPORTED_MODULE_6_lodash_pick___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_mapValues___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default()(attributes, 'property'), 'value'), propertiesToFind);
        return __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default()(attributesObject, attributesToFindObject);
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      var attributesSet = [[]]; // All attributes set list
      this.productPropertiesToChoose.forEach(function (property) {
        var valuesSelected = _this2.variantsOptions[property.id];
        var values = property.required ? valuesSelected : valuesSelected && valuesSelected.length ? valuesSelected : [''];
        attributesSet = __WEBPACK_IMPORTED_MODULE_8_lodash_flatten___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(values, function (value) {
          return attributesSet.map(function (attributes) {
            return [].concat(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(attributes), [{ property: property.id, value: value }]);
          });
        }));
      });
      var variants = [].concat(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(attributesSet.map(function (attributes) {
        return _this2.getVariantWithAttributes(attributes) || {
          reference: '',
          published: false,
          attributes: attributes
        };
      })), __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.deleteOldVariants ? [] : this.oldVariants), __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.deleteInvalidVariants ? [] : this.invalidVariants));
      this.$emit("submit", variants);
    },
    onCancel: function onCancel() {
      this.$emit("cancel");
    }
  }
});

/***/ }),

/***/ 924:
/*!******************************************************!*\
  !*** ./src/pages/products/VariantsGeneratorForm.vue ***!
  \******************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_VariantsGeneratorForm_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./VariantsGeneratorForm.vue */ 865);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3601c7f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VariantsGeneratorForm_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3601c7f2","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./VariantsGeneratorForm.vue */ 928);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_VariantsGeneratorForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3601c7f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VariantsGeneratorForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 925:
/*!***********************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/object/keys.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/object/keys */ 926), __esModule: true };

/***/ }),

/***/ 926:
/*!********************************************************!*\
  !*** ./node_modules/core-js/library/fn/object/keys.js ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es6.object.keys */ 927);
module.exports = __webpack_require__(/*! ../../modules/_core */ 6).Object.keys;


/***/ }),

/***/ 927:
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.object.keys.js ***!
  \*****************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(/*! ./_to-object */ 79);
var $keys = __webpack_require__(/*! ./_object-keys */ 138);

__webpack_require__(/*! ./_object-sap */ 418)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 928:
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3601c7f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/products/VariantsGeneratorForm.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('p',[_vm._v("\n    Vous êtes sur le point de générer les déclinaisons pour le produit "),_c('strong',[_vm._v(_vm._s(_vm.value.name)+" ?")])]),_vm._v(" "),_c('row',_vm._l((_vm.productPropertiesToChoose),function(property){return _c('column',{key:property.id,attrs:{"sm":"4"}},[_c('form-group',{attrs:{"label":property.name,"required":property.required}},[_c('form-multiselect',{attrs:{"options":_vm.getPropertyOptions(property),"select-all":"","multiple":""},model:{value:(_vm.variantsOptions[property.id]),callback:function ($$v) {_vm.$set(_vm.variantsOptions, property.id, $$v)},expression:"variantsOptions[property.id]"}})],1)],1)}),1),_vm._v(" "),(_vm.invalidVariants.length)?_c('p',[_c('form-checkbox',{model:{value:(_vm.deleteInvalidVariants),callback:function ($$v) {_vm.deleteInvalidVariants=$$v},expression:"deleteInvalidVariants"}},[_vm._v(" Supprimer les "+_vm._s(_vm.invalidVariants.length)+" déclinaisons invalides")])],1):_vm._e(),_vm._v(" "),(_vm.oldVariants.length)?_c('p',[_c('form-checkbox',{model:{value:(_vm.deleteOldVariants),callback:function ($$v) {_vm.deleteOldVariants=$$v},expression:"deleteOldVariants"}},[_vm._v(" Supprimer les "+_vm._s(_vm.oldVariants.length)+" anciennes déclinaisons")])],1):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Avec cette configuration, le produit contiendra au total "),_c('strong',[_vm._v(_vm._s(_vm.totalVariantsCount + (_vm.deleteInvalidVariants? 0: _vm.invalidVariants.length) + (_vm.deleteOldVariants? 0: _vm.oldVariants.length))+" déclinaison(s)")]),_vm._v(".")]),_vm._v(" "),_c('form-button',{attrs:{"kind":_vm.newVariantsCount > 0? 'submit': 'delete',"type":"submit"}},[_vm._v("\n     Mettre à jour\n  ")]),_vm._v(" "),_c('form-button',{attrs:{"kind":"cancel"},on:{"click":_vm.onCancel}},[_vm._v("Annuler")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// 20.3a2736f8.chunk.js